import React, { useContext } from 'react';
import styled from 'styled-components/macro';

import PlayerContext from '@mirinae/lessons/modules/contexts/player';
import GlobalContext from '@mirinae/lessons/modules/contexts/global';
import Element, { MissingElement } from '@mirinae/lessons/components/lesson/elements/Element';

const FrameWrapper = styled(Element)`
    border: thin solid plum;
`;

//  TODO:  incomplete...

const Frame = ({ element, frame }) => {
    const player = useContext(PlayerContext);
    const global = useContext(GlobalContext);

    return (
        <FrameWrapper element={element} frame={frame}>
            { frame.children.map((c, i) => {
                if (c.nodeID) {
                    // leaf element, render as
                    const e = global.currentLessonObject.nodeMap[c.nodeID];
                    const ElementComponent = player.componentMap.elementComponents[e.type] || MissingElement;
                    return ElementComponent && <ElementComponent key={e.title} element={e} />;
                } else {
                    // nested frame, recurse
                    <Frame key={i} element={element} frame={c} />;
                }
            })}
        </FrameWrapper>
    );
};

const CustomFrame = ({ element }) => {

    return (element.frameNestings ? (
        <Frame element={element} frame={element.frameNestings} />
    ) : (
        <MissingElement element={element} />
    ));
};

export default CustomFrame;
